import { Container, H1, P500 } from "./StaticPagesComponents";
import React, { Fragment } from "react";
import { FooterAds } from "../../components/ads/FooterAds";

export const Statement2257Page = () => {
  return (
    <Fragment>
      <Container className="page narrow">
        <H1>
          RedGIFs.com 18 U.S.C 2257 Statement
        </H1>

        <P500>
          All persons that appear in any visual depiction of actual sexually explicit conduct appearing or
          otherwise contained in this Website are required to be over the age of eighteen years at the time of the creation of such depictions.
          <br /><br />
          Various visual depictions displayed on this Website are exempt from the provision of 18 U.S.C. section 2257
          and 28 C.F.R. 75 because said visual depictions do not consist of depictions of conduct as specifically listed
          in 18 U.S.C section 2256 (2) (A) through (D), but are merely depictions
          of non-sexually explicit nudity, or are depictions of simulated sexual conduct, or are otherwise exempt because the visual depictions were
          created prior to July 3rd, 1995.
          <br /><br />
          RedGIFs.com is not the “producer” of the user-provided content found on RedGIFs.com. RedGIFs’ activities in providing a point of display for
          such content are limited to the display, transmission, storage, retrieval, hosting and/or formatting of depictions posted
          by third party users, on areas of the website under the user's control.
          Records required by 18 U.S.C. § 2257 are held by the producer(s) of such content and
          requests for records should be directed to the producer(s).
          <br /><br />
          For further information, please contact RedGIFs support at
          <a href="mailto:support@redgifs.com?subject=2257%20Statement">support@redgifs.com</a>.
        </P500>
      </Container>

      <FooterAds/>
    </Fragment>
  );
};
